// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4220":"d0a8a917","4707":"37afc6b7","5596":"df79aa45","6969":"7e736155"}[chunkId] + ".chunk.css";
};